import 'css-chunksrc/client/scenes/moveElement/projectsSelection/search/styles.scss';export default {
  "search": "_search_njf4v_1"
};